module.exports = __webpack_public_path__ + "d98b712986ccede56c566525fec9a104.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/red-skateboard.png
// module id = 1586
// module chunks = 0